import { useEffect, useState } from "react";
import { fetchProAdminDashboardData } from "../Services/ProAdminDashboardService";

const useProAdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const data = await fetchProAdminDashboardData(token);
        console.log("................ Dashboard data:", data);
        setDashboardData(data);
      } catch (err) {
        console.error(" Error fetching dashboard data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useProAdminDashboard;
